module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mxr-product-item"
  }, [_c('figure', {
    staticClass: "mxr-product-item__figure"
  }, [_c('div', {
    staticClass: "mxr-product-item__img"
  }, [(_vm.selectedColor && _vm.product.productInfo.productId === _vm.selectedColor[1]) ? _c('img', {
    attrs: {
      "src": ("" + (_vm.selectedColor[0].openGraph.image)),
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": ("" + (_vm.product.openGraph.image)),
      "alt": ""
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a51649e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductPic.vue
// module id = 459
// module chunks = 1